"use client";

import { ActionLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUITileInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { EventOrigin } from "@faire/deprecated-retailer-visitor-shared/features/InsightsFeed/events";
import {
  InsightCardContext,
  InsightCardContextProvider,
} from "@faire/deprecated-retailer-visitor-shared/features/InsightsFeed/InsightCardContext";
import { MuteModal } from "@faire/deprecated-retailer-visitor-shared/features/InsightsFeed/MuteModal";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import React, { useContext, useState } from "react";

import { BrandInsightsTileContents } from "./BrandInsightsTile/BrandInsightsTileContents";
import { MutedBrandInsightsTileContents } from "./BrandInsightsTile/MutedBrandInsightsTileContents";

export const SDUIBrandInsightsTileRenderer = (
  props: SDUITileInstanceRendererProps
) => (
  <InsightCardContextProvider origin={getEventOrigin(props.loggingData)}>
    <SDUIBrandInsightsTileRendererBase {...props} />
  </InsightCardContextProvider>
);

const SDUIBrandInsightsTileRendererBase = ({
  tileElement,
  loggingData,
}: SDUITileInstanceRendererProps) => {
  const [isMuteModalOpen, setIsMuteModalOpen] = useState(false);
  const { mutedBrands, onChangeMute, containerOrigin } =
    useContext(InsightCardContext);

  const { metadata } = tileElement.brand_insights_tile ?? {};
  const isMuted = (mutedBrands ?? []).includes(metadata?.brand_token ?? "");

  return (
    <>
      {isMuteModalOpen ? (
        <MuteModal
          brandName={metadata?.brand_name ?? ""}
          brandToken={metadata?.brand_token ?? ""}
          isMuted={isMuted}
          onChangeMute={onChangeMute}
          onClose={() => setIsMuteModalOpen(false)}
          containerOrigin={containerOrigin ?? ""}
        />
      ) : null}
      <div
        className="flex h-full w-full"
        data-testid="sdui-brand-insights-tile"
      >
        {isMuted ? (
          <MutedBrandInsightsTileContents
            brandName={metadata?.brand_name ?? ""}
            onUndoMuteClick={() => setIsMuteModalOpen(true)}
          />
        ) : (
          <BrandInsightsTileContents
            tileElement={tileElement}
            loggingData={loggingData}
            onMuteClick={() => setIsMuteModalOpen(true)}
          />
        )}
      </div>
    </>
  );
};

const getEventOrigin = (loggingData: ActionLoggingEventParams) => {
  // right now home page is the only surface that uses SDUI Insights Tile
  if (loggingData.view_display_page === DisplayPageType.HOMEPAGE) {
    return EventOrigin.HomeFeed;
  }

  return EventOrigin.Unknown;
};
